import React from 'react';
import Languages from '../languages';
import { injectIntl } from 'react-intl'

class UnAuthHeader extends React.Component {
    render() {
        return (
            <header className="ta--flex ta--justify-between ta--align-center rtl--row-reverse">
                <div className="ta--logo">{this.props.intl.messages.aff_logo}</div>
                <Languages></Languages>
            </header>
        );
    }
}

export default injectIntl(UnAuthHeader);


// WEBPACK FOOTER //
// ./src/components/header/UnAuthHeader.js